<template>
  <HeadTitle
    title="Grupos de nóminas"
    description="Lista de grupos de nóminas de una compañia seleccionada"
  />
  <Toolset
    ref="toolset"
    :searcher="onSearch"
    add-button-icon="pi pi-plus"
    add-button-label="Crear grupo de nóminas"
    :to-add="toAdd"
    class="mt-3"
  />
  <br />
  <DataTable
    class="tabla mb-5"
    :value="payrollsConfig"
    lazy
    paginator
    :rows="lazyParams.limit"
    :rowsPerPageOptions="[5, 10, 20, 50]"
    tableStyle="min-width: 50rem"
    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    :totalRecords="totalRecords"
    :currentPageReportTemplate="currentPageReportTemplate"
    scrollable
    scrollHeight="600px"
    @page="onPage"
    @sort="onSort"
  >
    <template #empty>
      No se encontraron grupos de configuracion de nóminas.</template
    >
    <Column field="client" header="Cliente">
      <template #body="{ data }">
        {{ data?.client.code }}-{{ data?.client.name }}
      </template>
    </Column>
    <Column field="company" header="Compañia">
      <template #body="{ data }">
        {{ data?.company.code }}-{{ data?.company.name }}
      </template>
    </Column>
    <Column field="description" header="Descripción"></Column>
    <Column field="cantPayrolls" header="Cant. Nóminas"></Column>
    <Column field="cantModules" header="Cant. Modulos"></Column>
    <Column field="updatedAt" header="Última actualización" sortable>
      <template #body="{ data, field }">
        <span>{{ formatDateWithHour(data[field]) }}</span>
      </template>
    </Column>
    <Column header="Acciones">
      <template #body="{ data }">
        <ConfirmPopup></ConfirmPopup>
        <div class="actions">
          <Button
            v-tooltip.bottom="'Ver detalles'"
            class="action-btn view p-button-sm mr-2 shadow-1"
            icon="pi pi-eye"
            @click="goToDetails(data['id'])"
          />
          <Button
            v-tooltip.bottom="'Flujos de aprobación'"
            class="action-btn view p-button-sm px-4 bg-gray-300 border-gray-400 mr-2 shadow-1"
            @click="goToApprovalFlows(data['id'])"
          >
            <img src="../../../assets/custom_icons/Flow.svg" alt="Flow icon" />
          </Button>
          <Button
            v-tooltip.bottom="'Documentos'"
            class="action-btn view p-button-sm px-4 bg-gray-300 border-gray-400 shadow-1"
            @click="goToDocumentGroups(data['id'])"
          >
            <i class="pi pi-book text-primary"></i>
          </Button>
          <Button
            v-if="data.client.integrationtype.code !== '001'"
            v-tooltip.bottom="'Feriados y días hábiles'"
            class="action-btn view p-button-sm px-4 bg-gray-300 border-gray-400 shadow-1 ml-2"
            @click="goToCalendarGroups(data['id'])"
          >
            <i class="pi pi-stopwatch text-primary"></i>
          </Button>
          <Button
            v-if="data.client.integrationtype.code !== '001'"
            v-tooltip.bottom="'Calendarios'"
            class="action-btn view p-button-sm px-4 bg-gray-300 border-gray-400 shadow-1 ml-2"
            @click="goToCalendarPeriods(data['id'])"
          >
            <i class="pi pi-calendar text-primary"></i>
          </Button>
        </div>
      </template>
    </Column>
  </DataTable>
</template>
<script lang="ts" setup>
  import { useRouter } from 'vue-router'

  // Components
  import Toolset from '@/shared/components/Toolset.vue'
  import HeadTitle from '@/shared/components/HeadTitle.vue'

  // Composables & Stores
  import { usePayrollsConfig } from '../composables/usePayrollsConfig'

  // Utils
  import { formatDateWithHour } from '@/shared/utils/fomartDateWithHours'
  import { ref } from 'vue'

  const router = useRouter()
  const toolset = ref()
  const {
    payrollsConfig,
    totalRecords,
    lazyParams,
    currentPageReportTemplate,
    onPage,
    onSort,
    onFilter,
  } = usePayrollsConfig()

  const toAdd = () => {
    router.push('/payrollsConfig/add')
  }

  const onSearch = () => {
    console.log('SEARCH', toolset.value)
    onFilter(toolset.value.search)
  }

  const goToDetails = (id: string) => {
    router.push('/payrollsConfig/' + id)
  }

  const goToApprovalFlows = (id: string) => {
    router.push('/payrollsConfig/' + id + '/approvalFlows')
  }

  const goToDocumentGroups = (id: string) => {
    router.push('/payrollsConfig/' + id + '/documentGroups')
  }

  const goToCalendarGroups = (id: string) => {
    router.push('/payrollsConfig/' + id + '/calendarGroups')
  }

  const goToCalendarPeriods = (id: string) => {
    router.push('/payrollsConfig/' + id + '/calendarPeriods')
  }
</script>
<style scoped>
  .tabla {
    margin-top: 1rem;
    box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1),
      0px 4px 5px -2px rgba(0, 0, 0, 0.12),
      0px 10px 15px -5px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    width: 90%;
  }

  .actions {
    display: flex;
    width: auto;
    flex-direction: row;
  }

  .action-btn {
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :deep(.p-column-title) {
    font-size: 14px;
  }

  :deep(.p-datatable-tbody) {
    font-size: 14px;
  }

  :deep(.p-paginator) {
    display: flex;
    align-items: center;
    justify-content: end;
    flex-wrap: wrap;
    font-size: 14px;
  }
</style>
